/* eslint-disable class-methods-use-this */
import {
  PEOPLE_SAVINGS,
  PROVIDERS_SAVINGS,
  VOLUME,
  VOLUMEN_SPREAD,
} from '../constants';
import { StepValues } from '../types';

export default class CalculateSavingsService {
  private getVolumeSaved = (step1: number): number => {
    if (!step1) {
      return 0;
    }
    if (step1 <= VOLUME[0].key) {
      return step1 * VOLUMEN_SPREAD[0];
    }
    if (step1 <= VOLUME[1].key) {
      return step1 * VOLUMEN_SPREAD[1];
    }
    if (step1 <= VOLUME[2].key) {
      return step1 * VOLUMEN_SPREAD[2];
    }
    return step1 * VOLUMEN_SPREAD[3];
  };

  calculateSavings = (values: StepValues) => {
    const { step1, step2, step3 } = values;
    const volumeSaved = step1 ? this.getVolumeSaved(Number(step1)) : 0;
    const providerSaved = step2 ? Number(step2) * PROVIDERS_SAVINGS : 0;
    const peopleSaved = step3 ? PEOPLE_SAVINGS[Number(step3)] : 0;
    const finalAmount = volumeSaved + providerSaved + peopleSaved;
    return finalAmount;
  };
}
